module.exports = __webpack_public_path__ + "img/3.734a1d86.png";